import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IngredientCardClickEvent } from '@app/mpp/model/ingredient-card-click-event';
import { IngredientCard } from '@app/mpp/model/ingredient-card-model';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-ingredients-desktop-tablet',
  templateUrl: './ingredients-desktop-tablet.component.html',
  styleUrls: ['./ingredients-desktop-tablet.component.scss'],
})
export class IngredientsDesktopTabletComponent {
  @Input() ingredients: IngredientCard[];
  @Input() containerSize = 12;
  @Input() selectedIngredient: string;
  @Input() searchKey: string;
  @Input() platform: PlatformEnum;

  @Output() ellipsisSelectionEvent = new EventEmitter<string>();
  @Output() updateCardDataEvent = new EventEmitter<string>();
  @Output() addIngredientsEvent = new EventEmitter<void>();
  @Output() dragDropEvent = new EventEmitter<string>();
  @Output() searchEvent = new EventEmitter<string>();
  @Output() nameClickEvent = new EventEmitter<IngredientCardClickEvent>();
  @Output() uomDropdownClickEvent =
    new EventEmitter<IngredientCardClickEvent>();
  @Output() noteInputBlurEvent = new EventEmitter<IngredientCardClickEvent>();
  @Output() quantityInputBlurEvent =
    new EventEmitter<IngredientCardClickEvent>();
  @Output() ellipsisEvent = new EventEmitter<IngredientCardClickEvent>();
  @Output() costInfoIconEvent = new EventEmitter<Event>();
  @Output() dismissCostInfoPopover = new EventEmitter();

  platformRef = PlatformEnum;
  constructor() {}

  onUomDropdownClickEvent(ingredientCardClickEvent: IngredientCardClickEvent) {
    this.uomDropdownClickEvent.emit(ingredientCardClickEvent);
  }

  onNoteInputBlurEvent(ingredientCardClickEvent: IngredientCardClickEvent) {
    this.noteInputBlurEvent.emit(ingredientCardClickEvent);
  }

  onQuantityInputBlurEvent(ingredientCardClickEvent: IngredientCardClickEvent) {
    this.quantityInputBlurEvent.emit(ingredientCardClickEvent);
  }

  onNameClick(ingredientCardClickEvent: IngredientCardClickEvent) {
    if (this.platform === this.platformRef.desktop)
      this.nameClickEvent.emit(ingredientCardClickEvent);
  }

  onAddIngredients() {
    this.addIngredientsEvent.emit();
  }

  onEllipsisClick(ingredientCardClickEvent: IngredientCardClickEvent) {
    this.ellipsisEvent.emit(ingredientCardClickEvent);
  }

  clickInfoIcon = ($event: Event) => {
    this.costInfoIconEvent.emit($event);
  };

  dismissCostInfoPopoverEvent() {
    this.dismissCostInfoPopover.emit();
  }
}
